import React from "react";

export default function MySQL_LEAST() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_LEAST</h1>
      <p>This is the MySQL_LEAST component generated from the SQL JSON.</p>
    </div>
  );
}
